import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { ZitadelServiceUser } from "@src/types/user-management";

export interface GetServiceUsersResult {
  success: boolean;
  data?: ZitadelServiceUser[];
  error?: string;
}

export const getServiceUsersUseCase = async (
  signal: AbortSignal,
): Promise<GetServiceUsersResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.getServiceUsers(namespace, signal);

    return {
      success: true,
      data: response?.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(
        error,
        "Failed to fetch service users. Please try again later.",
      ).message,
    };
  }
};
